import React, { PureComponent } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import _ from 'lodash';
import fp from 'lodash/fp';
import { connect } from 'react-redux';
import { toCurrency, mapState, color } from '@deerplusofficial/pos-helper';
import { Button as ButtonBase } from '@deerplusofficial/pos-components';
import CartPreOrderDetailFooter from './CartPreOrderDetailFooter';
import actions from '../../actions';
import withCartProps from '../../assist/withCartProps';
import { withQueryPreOrders } from '../../model/Queries';

const Container = styled.div`
  display: flex;
`;

const Nowrap = styled.span`
  white-space: nowrap;
`;

const Button = styled(ButtonBase).attrs({ tall: true })`
  border-radius: 0;
  flex-grow: 1;
`;

const CheckoutButtonInner = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const Price = styled.div`
  margin-left: 18px;
  font-size: 30px;
`;

const PreOrderLabel = styled.span`
  display: inline-block;
  margin-left: 8px;
  padding: 4px;
  min-width: 20px;
  font-size: 12px;
  border-radius: 8px;
  background-color: ${color.error};
  line-height: 1;
  color: white;
`;

class CartFooter extends PureComponent {
  static propTypes = {
    checkoutPrice: PropTypes.number,
    disabled: PropTypes.bool,
    readonly: PropTypes.bool,
  };

  static defaultProps = {
    checkoutPrice: 0,
    disabled: true,
    readonly: false,
  };

  componentDidMount() {
    const { fetchPreOrders } = this.props;
    fetchPreOrders();
  }

  onCheckout = () => {
    const { editOrderStep, editOrderPrice, checkoutPrice } = this.props;
    editOrderPrice(checkoutPrice);
    editOrderStep('checkout');
  };

  renderCheckoutButton = () => {
    const { disabled, checkoutPrice } = this.props;
    return (
      <Button primary onClick={this.onCheckout} disabled={disabled}>
        <CheckoutButtonInner>
          <Nowrap>{disabled ? '結帳金額' : '立即結帳'}</Nowrap>
          <Price>{toCurrency(checkoutPrice)}</Price>
        </CheckoutButtonInner>
      </Button>
    );
  };

  renderPreOrderButton = () => {
    const {
      togglePreOrderList,
      togglePreOrderDetail,
      disabled,
      preOrder: { list },
    } = this.props;

    if (!disabled)
      return (
        <Button info onClick={togglePreOrderDetail}>
          稍後付款
        </Button>
      );

    const pendingCount = _.size(list);

    if (!pendingCount) return;

    return (
      <Button info onClick={togglePreOrderList}>
        待付款列表<PreOrderLabel>{pendingCount}</PreOrderLabel>
      </Button>
    );
  };

  render() {
    const { preOrder, readonly } = this.props;

    if (!preOrder.isEnabled || readonly)
      return <Container>{this.renderCheckoutButton()}</Container>;

    if (preOrder.isDetailOpen) return <CartPreOrderDetailFooter />;

    return (
      <Container>
        {this.renderPreOrderButton()}
        {this.renderCheckoutButton()}
      </Container>
    );
  }
}

const { edit: editOrderPrice } = actions.order.price;
const { edit: editOrderStep } = actions.orderStep;
const {
  list: { toggle: togglePreOrderList },
  detail: { toggle: togglePreOrderDetail },
} = actions.preOrder;

export default fp.compose(
  withCartProps(),
  withQueryPreOrders(),
  connect(
    mapState(['preOrder']),
    {
      editOrderStep,
      editOrderPrice,
      togglePreOrderList,
      togglePreOrderDetail,
    }
  )
)(CartFooter);



// WEBPACK FOOTER //
// ./src/components/Cart/CartFooter.js